import angular from 'angular';
import BoxProductsComponent from './box-products.component';

let BoxProductsModule = angular.module('catalog.productsModules.boxProducts', [])
  .component('boxProducts', BoxProductsComponent);

export default BoxProductsModule;



// WEBPACK FOOTER //
// ./www/components/catalog/box-products/box-products.js